import {BaseEvent} from "../BaseEvent";

export class ApplicationOnlineStatusChangedBody {
  public status!: boolean;
  public version!: string;

  constructor(status: boolean, version: string) {
    this.status = status;
    this.version = version;
  }
}

export class ApplicationOnlineStatusChangedNtf extends BaseEvent {
  public static NAME = 'applicationOnlineStatusChanged';
  public value: ApplicationOnlineStatusChangedBody;

  constructor(status: ApplicationOnlineStatusChangedBody) {
    super(ApplicationOnlineStatusChangedNtf.NAME);

    this.value = status;
  }
}
